var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card-text',[_c('h2',{staticClass:"title mt-4 mb-2"},[_vm._v("Completed trade pairs last 7 days")]),_vm._v(" "),_c('Chart',{attrs:{"chart-data":_vm.datasets,"height":200}})],1)],1)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-349f8aca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/dashboard/GraphProfitTradeWrapper.vue
// module id = PmgV
// module chunks = 0